import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';

export default function CartButton() {
  const { itemCount } = useCart();

  return (
    <Link
      to="/cart"
      className="relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-gold/10 transition-colors cursor-pointer"
      aria-label="Shopping cart"
    >
      <i className="ri-shopping-cart-line text-xl text-charcoal"></i>
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-gold text-white text-xs font-medium rounded-full w-5 h-5 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </Link>
  );
}
